import { generateRequest } from '.';

export const Action = {
  Station: {
    EmergencyStatusPending: 'EmergencyStatus_PENDING',
    EmergencyStatusCompleted: 'EmergencyStatus_FULFILLED',
    EmergencyStatusFailed: 'EmergencyStatus_FAILED',
  },
};

export const fetchEmergencyStatusByStationById = stationId => generateRequest({
  endpoint: `/assets-v2/api/stations/${stationId}/emergency_status`,
  types: [
    Action.Station.EmergencyStatusPending,
    Action.Station.EmergencyStatusCompleted,
    Action.Station.EmergencyStatusFailed,
  ],
});
